// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__BTqXD","errors":"Errors_errors__1CH3Y"};